/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseDateFieldLook = {
    DateAndTimeLook: 'DATE_FIELD_DATE_AND_TIME_LOOK',
    OnlyDateLook: 'DATE_FIELD_ONLY_DATE_LOOK',
    OnlyTimeLook: 'DATE_FIELD_ONLY_TIME_LOOK'
} as const;
export type DatabaseDateFieldLook = typeof DatabaseDateFieldLook[keyof typeof DatabaseDateFieldLook];


export function DatabaseDateFieldLookFromJSON(json: any): DatabaseDateFieldLook {
    return DatabaseDateFieldLookFromJSONTyped(json, false);
}

export function DatabaseDateFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDateFieldLook {
    return json as DatabaseDateFieldLook;
}

export function DatabaseDateFieldLookToJSON(value?: DatabaseDateFieldLook | null): any {
    return value as any;
}

